import React, { useEffect, useState } from 'react';
import AnimatedLetters from './AnimatedLetters';

const experiences = [
  {
    role: 'Low Code | No Code | Solutions Engineer',
    company: 'Boolean',
    period: 'December 2024 – Present',
    current: true,
    bullets: [
      'Automated HubSpot deal creation triggered by appointment bookings, eliminating manual data entry and accelerating the sales pipeline.',
      'Designed and deployed an Airtable interface to centrally manage jobs, deals, and financing — enabling real-time visibility and streamlined operations.',
      'Built Make.com workflows integrating HubSpot CRM with third-party scheduling tools to maintain data accuracy across all platforms.',
    ],
  },
  {
    role: 'Automation Specialist — IT Specialist 3',
    company: 'My Amazon Guy',
    period: 'November 2023 – December 2024',
    current: false,
    bullets: [
      'Developed and implemented HubSpot workflows that streamlined the sales process, leading to a 20% increase in lead conversion rates.',
      'Designed and deployed Zapier automation for the ticketing system, reducing response time by 30% and enhancing customer satisfaction.',
      'Collaborated with cross-functional teams to identify automation gaps and implement solutions that improved overall operational efficiency.',
    ],
  },
];

const Experience = () => {
  const [letterClass, setLetterClass] = useState('text-animate-underline');

  useEffect(() => {
    setTimeout(() => setLetterClass('text-animate-underline-hover'), 3000);
  }, []);

  return (
    <div name='experience' className='w-full bg-[#0a192f] text-gray-300 scroll-mt-20'>
      <div className='max-w-[1000px] mx-auto p-4 py-16'>
        <div className='pb-8 mt-4'>
          <p className='text-4xl font-bold'>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['E', 'x', 'p', 'e', 'r', 'i', 'e', 'n', 'c', 'e']}
              idx={10}
            />
          </p>
          <p className='py-4 text-gray-400'>Where I've worked and what I've built.</p>
        </div>

        {/* Timeline */}
        <div className='relative'>
          {/* Vertical line */}
          <div className='absolute left-4 md:left-8 top-0 bottom-0 w-0.5 bg-[#ffd700]/30' />

          <div className='space-y-10'>
            {experiences.map((exp, i) => (
              <div key={i} className='relative flex gap-6 md:gap-10 pl-12 md:pl-20'>
                {/* Dot */}
                <div className={`absolute left-2 md:left-6 top-1.5 w-5 h-5 rounded-full border-2 border-[#ffd700] flex items-center justify-center ${exp.current ? 'bg-[#ffd700]' : 'bg-[#0a192f]'}`}>
                  {exp.current && <div className='w-2 h-2 rounded-full bg-[#0a192f]' />}
                </div>

                <div className='flex-1'>
                  <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between mb-1 gap-1'>
                    <h3 className='text-lg font-bold text-[#ccd6f6]'>{exp.role}</h3>
                    <span className={`text-sm font-semibold px-3 py-0.5 rounded-full w-fit ${exp.current ? 'bg-[#ffd700]/20 text-[#ffd700]' : 'bg-gray-700/50 text-gray-400'}`}>
                      {exp.period}
                    </span>
                  </div>
                  <p className='text-[#ffd700] font-medium mb-3 text-sm'>{exp.company}</p>
                  <ul className='space-y-2'>
                    {exp.bullets.map((b, j) => (
                      <li key={j} className='flex gap-2 text-gray-400 text-sm leading-relaxed'>
                        <span className='text-[#ffd700] mt-1 flex-shrink-0'>▹</span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
